<template>
  <div>
    <p class="text-left" style="padding-left: 10px">
      Medidas de sismografía cercanas
    </p>
    <!-- Tabla con la lista de medidas-->
    <div class="groupBox">
      <vue-good-table
        id="sismoTable"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        :totalRows="totalRecords"
        :columns="columns"
        :rows="rows"
        ref="sismoData"
        :search-options="{
          skipDiacritics: true,
          placeholder: 'Buscar en la tabla',
        }"
        :pagination-options="{
          enabled: true,
          nextLabel: '',
          prevLabel: '',
          rowsPerPageLabel: 'Filas por pagina',
          ofLabel: 'de',
          pageLabel: 'pagina', // for 'pages' mode
          allLabel: 'Todas',
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'raw_ts', type: 'desc' },
        }"
        :isLoading.sync="isLoading"
      >
        <template slot="loadingContent">
          <table-loading />
        </template>
        <template slot="emptystate">
          <table-empty-state />
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import DataService from "@/services/DataService";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";

export default {
  name: "sismo-list",
  data() {
    return {
      location: null,
      totalRecords: 0,
      isLoading: false,
      columns: [
        {
          label: "# UUID",
          thClass: "text-center",
          tdClass: "text-center",
          field: "uuid",
          hidden: true,
        },
        {
          label: "Fecha",
          field: "fecha_completa",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "200px",
        },
        {
          label: "Evento",
          field: "evento",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
        },

        {
          label: "Latitud",
          thClass: "text-center",
          tdClass: "text-center",
          field: "latitud",
        },
        {
          label: "Longitud",
          thClass: "text-center",
          tdClass: "text-center",
          field: "longitud",
        },
        {
          label: "Profundidad",
          thClass: "text-center",
          tdClass: "text-center",
          field: "profundidad",
        },
        {
          label: "Intensidad",
          thClass: "text-center",
          tdClass: "text-center",
          field: "intensidad",
        },
        {
          label: "Magnitud",
          thClass: "text-center",
          tdClass: "text-center",
          field: "magnitud",
        },
        {
          label: "Tipo de magnitud",
          thClass: "text-center",
          tdClass: "text-center",
          field: "tipo_magnitud",
        },
        {
          label: "Localización",
          thClass: "text-center",
          tdClass: "text-center",
          field: "localizacion",
        },
      ],
      rows: [],
      serverParams: {
        columnFilters: {},
        sort: {
          field: "fecha_completa",
          type: "desc",
        },
        page: 1,
        perPage: 10,
      },
    };
  },
  components: {
    VueGoodTable,
    "table-loading": TableLoading,
    "table-empty-state": TableEmptyState,
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      if (this.location) {
        this.updateParams({ page: params.currentPage });
        this.loadItems();
      }
    },

    onPerPageChange(params) {
      if (this.location) {
        this.updateParams({ perPage: params.currentPerPage });
        this.loadItems();
      }
    },

    async onSortChange(params) {
      if (this.location) {
        //onSortChange executes before retrieveDataFromSensor (which prepares the metadata neccesary), so it have to wait
        if (this.columns.length && this.columns.length > 0) {
          this.updateParams({
            page: 1,
            sort: {
              type: params[0].type,
              field: params[0].field,
            },
          });
          this.loadItems();
        }
      }
    },

    onColumnFilter(params) {
      if (this.location) {
        this.updateParams(params);
        this.loadItems();
      }
    },

    async loadItems() {
      this.isLoading = true;
      await DataService.getSismoDataByLocationId(
        this.location._id,
        this.serverParams
      )
        .then((filteredData) => {
          let data = filteredData.data;
          this.totalRecords = data.totalRecords;
          this.populateRows(data.data);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(
            "Error getting filtered data (Sismografia.vue :: loadItems)"
          );
          console.log(err);
        });
    },

    async retrieveSismoData(location) {
      this.isLoading = true;
      this.rows = [];
      this.customColumnNames = [];
      this.location = location;

      await DataService.getSismoDataByLocationId(
        this.location._id,
        this.serverParams
      )
        .then((filteredData) => {
          let dataResponse = filteredData.data;
          this.totalRecords = dataResponse.totalRecords;
          this.populateRows(dataResponse.data);
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          console.log("Error recuperando datos shm filtrados");
          console.log(e);
        });
    },

    async populateRows(data) {
      this.rows = [];

      //Add to array
      for (let i = 0; i < data.length; i++) {
        let d = data[i];

        //Create struct before insert it
        let newData = null;

        newData = {
          fecha_completa: this.$moment(String(d.data.fecha_completa))
            .local()
            .format("DD-MM-YYYY HH:mm:ss.SSS"),
          evento: d.data.evento ? d.data.evento : " - ",
          latitud: d.data.latitud ? d.data.latitud : " - ",
          longitud: d.data.longitud ? d.data.longitud : " - ",
          profundidad: d.data.profundidad ? d.data.profundidad : " - ",
          intensidad: d.data.intensidad ? d.data.intensidad : " - ",
          magnitud: d.data.magnitud ? d.data.magnitud : " - ",
          tipo_magnitud: d.data.tipo_magnitud ? d.data.tipo_magnitud : " - ",
          localizacion: d.data.localizacion ? d.data.localizacion : " - ",
        };

        //Push the data to the array
        this.rows.push(newData);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.sismoTable {
  padding: 20px 20px 20px 20px;
}
.titulo {
  font-size: 0.95rem;
  color: #606266;
  text-align: left;
  font-weight: 400;
}

.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
}

.innergroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}

.innergroupBoxAlt {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 10px;
}
</style>
